import {
  Alert,
  Button,
  Col,
  Form,
  Input,
  Modal,
  Row,
  Spin,
  message,
  Select,
  TimePicker,
} from "antd";
import React, { useEffect, useState, useRef, useContext } from "react";
import { LoadingOutlined } from "@ant-design/icons";
import SimpleReactValidator from "simple-react-validator";
import DashServices from "../../services/DashServices";
import ProtocolServices from "../../services/ProtocolServices";
import { translate } from "../../locale";
import moment from "moment";
import dayjs from "dayjs";

const { Option } = Select;
const { TextArea } = Input;

const AddProtocol = ({ visible, onComplete, onCancel }) => {
  const [loading, setLoading] = useState(false);
  const [active, setActive] = useState(false);
  const [values, setValues] = useState({
    name: "",
    dispatch_time: dayjs("1970-01-01 12:00", "HH:mm"),
  });
  const [error, setError] = useState("");
  const [, forceUpdate] = useState();

  const simpleValidator = useRef(
    new SimpleReactValidator({
      autoForceUpdate: { forceUpdate: forceUpdate },
      element: (message) => (
        <div className="text-red-600 pt-2 text-xs">{message}</div>
      ),
      messages: {
        required: "Campo requerido",
      },
    })
  );

  useEffect(() => {
    if (visible !== null) {
      setActive(visible);
    }
  }, [visible]);

  const disabled = () => !simpleValidator.current.allValid();

  const onFinish = async () => {
    setLoading(true);
    setError("");

    if (!simpleValidator.current.allValid()) {
      simpleValidator.current.showMessages();
      forceUpdate();

      setError("Todos los datos son requeridos");

      setLoading(false);

      return;
    }
    try {
      const data = {
        name: values.name,
        dispatch_time: values.dispatch_time.format("HH:mm"),
      };
      const res = await ProtocolServices.saveProtocol(data);
      if (res) {
        if (res.status >= 200 && res.status < 300) {
          message.success("El protocolo se guardó exitosamente.");
        } else {
          message.success(res.data.message, 3);
        }
        resetForm();
        setLoading(false);
        if (onComplete) {
          onComplete();
        }
      } else {
        setError("Log in error");
      }
    } catch (e) {
      console.log(e);
      setError(e.message);
      setLoading(false);
    }
  };

  const resetForm = () => {
    setValues({
      name: "",
      dispatch_time: dayjs("1970-01-01 12:00", "HH:mm"),
    });
    simpleValidator.current.hideMessages();
    simpleValidator.current.visibleFields = [];
    forceUpdate();
  };

  const handleChange = (name, value) => {
    console.log(name, value);
    setValues((v) => ({ ...v, [name]: value }));
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;
    simpleValidator.current.showMessageFor(name);
    setValues((v) => ({ ...v, [name]: value }));
  };

  const handleCancel = () => {
    resetForm();
    setActive(false);
    if (onCancel) {
      onCancel();
    }
  };
  return (
    <Modal
      open={active}
      title={translate("Agregar protocolo")}
      onOk={null}
      onCancel={handleCancel}
      footer={false}
    >
      {error && (
        <Alert
          message={error}
          type="error"
          className="mb-6"
          closable
          onClose={() => setError("")}
        />
      )}
      <Form
        initialValues={{ remember: true }}
        onFinish={onFinish}
        autoComplete="off"
        className="w-full"
      >
        <Form.Item>
          <Input
            placeholder="Nombre"
            className="border-custom_primary"
            name="name"
            onChange={(e) => handleChange("name", e.target.value)}
            onBlur={handleBlur}
            value={values.name}
          />
          {simpleValidator.current.message("name", values.name, "required")}
        </Form.Item>
        <Form.Item>
          <div>{translate("Hora de envío de notificaciones")}</div>
          <TimePicker
            format="HH:mm"
            placeholder="00:00"
            className="border-custom_primary"
            name="dispatch_time"
            defaultValue={dayjs("1970-01-01 12:00", "HH:mm")}
            onChange={(time) => handleChange("dispatch_time", time)}
            value={values.dispatch_time}
            minuteStep={10}
          />
          {simpleValidator.current.message(
            "dispatch_time",
            values.dispatch_time !== null
              ? values.dispatch_time.toString()
              : "",
            "required"
          )}
        </Form.Item>
        <Form.Item>
          <Row align="end" gutter={16}>
            <Col>
              <Button key="back" onClick={handleCancel}>
                Cancelar
              </Button>
            </Col>
            <Col>
              <Button
                disabled={disabled()}
                htmlType="submit"
                type="primary"
                className="bg-custom_primary"
              >
                {loading ? (
                  <Spin
                    indicator={<LoadingOutlined style={{ color: "#666666" }} />}
                  />
                ) : (
                  "Guardar"
                )}
              </Button>
            </Col>
          </Row>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default AddProtocol;
